export default __webpack_public_path__ + "0489a5dc819009bf3fa02f35239084ca.jpeg";